// extracted by mini-css-extract-plugin
export default {"mainClass":"candidate_mainClass__iNvMo","h1":"candidate_h1__Ewkpa","tabClass":"candidate_tabClass__BWujc"};